
























































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsApi } from "@/api/newsApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class SearchResult extends Vue {
  newsApi: NewsApi;
  contentType = "0";
  searchKey = "";
  dataList: Array<object> = [];
  pageNum = 1;
  listTotal = 0;
  contentTypeList = [
    { key: "0", title: "全部" },
    { key: "1", title: "时讯" },
    { key: "2", title: "图文" },
    { key: "3", title: "视频" },
  ];

  constructor() {
    super();
    this.newsApi = new NewsApi();
  }

  mounted() {
    this.searchKey = this.$route.query["k"]?.toString();
    this.getDataList();
  }

  viewDetail(type: number, id: number) {
    if (type == 99) {
      //视频
      this.$router.push({ path: "videoDetail", query: { id: id.toString() } });
    } else {
      this.$router.push({ path: "newsDetail", query: { id: id.toString() } });
    }
  }

  changeTab(tabIdx: string) {
    this.contentType = tabIdx;
    this.getDataList();
  }

  getDataList() {
    this.newsApi
      .searchList(this.pageNum, 10, this.searchKey, this.contentType)
      .then((res) => {
        this.dataList = res.data;
        this.listTotal = res.total;
      });
  }

  changeListPage(page: number, pageSize: number) {
    this.pageNum = page;
    this.getDataList();
  }
}
